import React from 'react'
import TreatmentCreate from '../treatment_components/treatmentCreate'
import { Card, CardContent, CardHeader } from '@mui/material'

export default function Main() {
  return (
    <div className='content-wrapper bg-white p-5' style={{ marginLeft: 0 }}>
      <div>
        <h2>Create Treatment</h2>
        <TreatmentCreate />
      </div>
    </div>
  )
}
